import GenerateCampaignModalLayout from "../../GenerateCampaign/GenerateCampaignModalLayout";
import GenerateCampaignFormGoogle from "./GenerateCampaignFormGoogle";

const GenerateCampaignGoogle = ({
  initialData = {},
  modalOpen,
  onCloseModal,
  campaignID,
  context,
  onCallbackSave = () => {},
  verifyBlockAlert,
}) => {
  return (
    <GenerateCampaignModalLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
    >
      <GenerateCampaignFormGoogle
        initialData={initialData}
        campaignID={campaignID}
        context={context}
        onCallbackSave={onCallbackSave}
        verifyBlockAlert={verifyBlockAlert}
      />
    </GenerateCampaignModalLayout>
  );
};

export default GenerateCampaignGoogle;
